import { Icon, IconSize } from '@/components/Icon';
import { defineComponent } from '@vue/composition-api';
import { SortDir } from '@/composables/use-sort';
import { mdiMenuDown } from '@mdi/js';
import SortArrowSvg from '@/assets/icons/sort-arrow.svg';
export default defineComponent({
    components: { Icon },
    props: {
        dir: {
            type: String,
        },
    },
    setup() {
        return { mdiMenuDown, IconSize, SortDir, SortArrowSvg };
    },
});
